module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/ErrorMobile.html -->\n<div class="middle-box text-center animated fadeInDown">\n    <img src="/images/payrollpanda-logo.png" width="300">\n    <h3 class="font-bold"></h3>\n    <div class="error-desc">\n        <p>Sorry but this version of the PayrollPanda application is currently only\n        available for use with a desktop computer. Check your email for your login details and sign in via a desktop computer.</p>\n        <p>Learn how PayrollPanda can help you save time in this 1-minute video:</p>\n        <iframe width="100%" src="https://www.youtube.com/embed/vsCENM-S6Fo" frameborder="0" allowfullscreen></iframe>\n        <p>If you have any questions you can reach us at admin@payrollpanda.my.</p>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/ErrorMobile.html
// module id = 624
// module chunks = 1